module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Clarence B. Jones, Stuart Connelly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Clarence B. Jones")]), _vm._v(" served as speechwriter and counsel to Martin Luther King, Jr. and is currently a scholar-in-residence and visiting professor at Stanford University's Martin Luther King, Jr. Institute. Selected by "), _c('I', [_vm._v("Time ")]), _vm._v("magazine in 1972 as one of \"The 100 Future Leaders of America,\" and twice recognized in "), _c('I', [_vm._v("Fortune")]), _vm._v(" magazine as \"A Businessman of the Month,\" Jones has received numerous state and national awards recognizing his significant contributions to American society. He lives in Palo Alto, CA. "), _c('br'), _c('B', [_vm._v("Stuart Connelly")]), _vm._v(" is an author and filmmaker. He is a recent National Educational Press Association Award winner and blogs for The Huffington Post. He divides his time between rural Pennsylvania and New York.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YWEP2N/tc-custom/9780230112384.jpg?1720831335648",
      "alt": "This image is the cover for the book Behind the Dream"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Behind the Dream\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"I have a dream.\" When those words were spoken on the steps of the Lincoln Memorial on August 28, 1963, the crowd stood, electrified, as Martin Luther King, Jr. brought the plight of African Americans to the public consciousness and firmly established himself as one of the greatest orators of all time. "), _c('i', [_vm._v("Behind the Dream ")]), _vm._v("is a thrilling, behind-the-scenes account of the weeks leading up to the great event, as told by Clarence Jones, co-writer of the speech and close confidant to King. Jones was there, on the road, collaborating with the great minds of the time, and hammering out the ideas and the speech that would shape the civil rights movement and inspire Americans for years to come.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0